export function formatDateDMY(dateString) {
  if (!dateString) return "__";
  const d = new Date(dateString);
  if (isNaN(d)) return "__";
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
}